import api from '@pray/shared/utils/api';

export async function updateMasterToggle({ leadCampaignId }) {
  if (!leadCampaignId) throw Error('Campaign ID is required');
  const url = `/web/studio/lead-campaigns/${leadCampaignId}/master-toggle`;
  const response = await api.executePutRequest(url, {});
  return response.data;
}
